import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "../../../../Utils/LoadMask/LoadMask";
import Paginacion from "../../../../Utils/Components/Paginacion/Paginacion";
import { useBitacoraFletes } from "../hooks/useBitacoraFletes";
import { ResumenFinca } from "./ResumenFinca";
import { FiltroFlete } from "./FiltroFlete";
import { BitacoraFletesTable } from "./BitacoraFletesTable";

export const Listado = ({ fincaId, regresar }) => {
    const bitacora = useBitacoraFletes(fincaId);

    return (
        <div className="bitacora-fletes__contenido">
            <LoadMask loading={bitacora.cargando} blur>
                <CardEmpty noShadow>
                    <ResumenFinca finca={bitacora.finca} />
                    <FiltroFlete bitacora={bitacora} />
                    <BitacoraFletesTable registros={bitacora.registros} />
                    <Paginacion
                        cantidadResultados={bitacora.cantidadResultados}
                        paginaSeleccionada={bitacora.paginaSeleccionada}
                        setPaginaSeleccionada={bitacora.setPaginaSeleccionada}
                    />
                    <div className="d-flex justify-content-center my-4">
                        <button
                            type="button"
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            REGRESAR
                        </button>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
